import React, { useState, useEffect,useContext } from "react";
import { Row, Col, Card, Table, Alert, ProgressBar, Spinner } from "react-bootstrap";
import axios from "axios";
import _ from "lodash";
import moment from "moment";
import Utils from "./../../common/Utils";
import ChoosePlans from "../../components/application/ChoosePlans";
import { UserContext } from "../../common";

const Dashboard = (props) => {
  const { userData } = useContext(UserContext);
  const [cardTheme, setCardTheme] = useState(() => {
    return localStorage.getItem("dt_card_theme") || "classic";
  });
  const [nowTime, setNowTime] = useState(moment().format("HH:mm:ss"));
  const [jobStat, setJobStat] = useState({ loading: false, stats: [] });
  const [taskStat, setTaskStat] = useState({ loading: false, stats: [] });
  const [summary, setSummary] = useState({
    loading: false,
    records: [],
    st: 0,
    total: 0,
  });

  const [myRotas, setMyRotas] = useState({ loading: false, records: [] });

  const fetchMyRota = () => {
    setMyRotas({ loading: true, records: [] });
    const dtf = moment().startOf('isoWeek').format('YYYY-MM-DD');
    const dtt = moment().endOf('isoWeek').format('YYYY-MM-DD');
    axios.get(Utils.apiUrl(`users/fetchrotas?filter[op]=my&filter[mode]=week&filter[dtf]=${dtf}&filter[dtt]=${dtt}`), Utils.apiHeaders())
      .then(res => {
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          setMyRotas({ loading: false, records: data.rotas || [] });
        } else {
          setMyRotas({ loading: false, records: [] });
        }
      })
      .catch(() => setMyRotas({ loading: false, records: [] }));
  };

  useEffect(() => {
    const timer = setInterval(() => {
      setNowTime(moment().format("HH:mm:ss"));
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  const fetchJobStats = () => {
    setJobStat({ ...jobStat, loading: true });
    axios
      .get(Utils.apiUrl("jobs/fetchstats"), Utils.apiHeaders())
      .then((res) => {
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          setJobStat({ loading: false, stats: data.stats });
          Utils.addToUserData({ jobs: data.stats[1] });
        } else {
          setJobStat({ ...jobStat, loading: false });
        }
      })
      .catch((err) => {
        setJobStat({ ...jobStat, loading: false });
        console.log(err);
      });
  };

  const fetchTaskStats = () => {
    setTaskStat({ ...taskStat, loading: true });
    axios
      .get(Utils.apiUrl("tasks/fetchstats"), Utils.apiHeaders())
      .then((res) => {
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          setTaskStat({ loading: false, stats: data.stats });
          Utils.addToUserData({ tasks: data.stats[1] });
        } else {
          setTaskStat({ ...taskStat, loading: false });
        }
      })
      .catch((err) => {
        setTaskStat({ ...taskStat, loading: false });
        console.log(err);
      });
  };

  const fetchTeamSummary = (st = 0) => {
    setSummary({ ...summary, loading: true });
    axios
      .get(Utils.apiUrl(`jobs/fetchteamsummary?pp=${Utils.perpage}&st=${st}`), Utils.apiHeaders())
      .then((res) => {
        const data = Utils.parseApiResponse(res);
        if (data.success) {
          var tmp = {
            ...summary,
            loading: false,
            records: data.records,
            st: st,
          };
          if (_.has(data, "total")) {
            tmp["total"] = data.total;
          }
          setSummary(tmp);
        } else {
          setSummary({ ...summary, loading: false });
        }
      })
      .catch((err) => {
        setSummary({ ...summary, loading: false });
        console.log(err);
      });
  };

  const showPagination = ({ loading, st, total }, callback) => {
    var pp = Utils.perpage;
    if (loading || (st === 0 && st + pp >= total)) {
      return <></>;
    } else {
      return (
        <div className="d-flex flex-row-reverse">
          {st + pp >= total && (
            <div className="text-disabled ms-2">
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
            </div>
          )}
          {st + pp < total && (
            <div className="clickable ms-2 text-clickable" onClick={() => callback(st + pp)}>
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
            </div>
          )}
          {st >= pp && (
            <div className="clickable text-clickable" onClick={() => callback(st - pp)}>
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
            </div>
          )}
          {st == 0 && (
            <div className="text-disabled">
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
            </div>
          )}
        </div>
      );
    }
  };

  const [liveShift, setLiveShift] = useState({
    clockedIn: false,
    checkInTime: null,
    checkOutTime: null,
    duration: "Not Clocked In",
    statusText: "Offline · Awaiting Clock In"
  });
  const liveShiftRef = React.useRef(liveShift);
  liveShiftRef.current = liveShift;

  const updateShiftDisplay = (checkIn, checkOut) => {
    if (checkIn) {
      const inTime = moment(checkIn);
      if (!checkOut) {
        const diffSec = Math.max(0, moment().diff(inTime, "seconds"));
        const hrs = String(Math.floor(diffSec / 3600)).padStart(2, "0");
        const mins = String(Math.floor((diffSec % 3600) / 60)).padStart(2, "0");
        const secs = String(diffSec % 60).padStart(2, "0");
        setLiveShift({
          clockedIn: true,
          checkInTime: inTime,
          checkOutTime: null,
          duration: `${hrs}:${mins}:${secs}`,
          statusText: `Shift Active · In at ${inTime.format("HH:mm")}`
        });
      } else {
        const outTime = moment(checkOut);
        const diffSec = Math.max(0, outTime.diff(inTime, "seconds"));
        const hrs = String(Math.floor(diffSec / 3600)).padStart(2, "0");
        const mins = String(Math.floor((diffSec % 3600) / 60)).padStart(2, "0");
        setLiveShift({
          clockedIn: false,
          checkInTime: inTime,
          checkOutTime: outTime,
          duration: `${hrs}h ${mins}m`,
          statusText: "Shift Completed Today"
        });
      }
    } else {
      setLiveShift({
        clockedIn: false,
        checkInTime: null,
        checkOutTime: null,
        duration: "Not Clocked In",
        statusText: "Offline · Awaiting Clock In"
      });
    }
  };

  const fetchLiveAttendance = () => {
    axios
      .get(Utils.apiUrl("attendence/livestatus"), Utils.apiHeaders())
      .then((res) => {
        const data = Utils.parseApiResponse(res);
        if (data.success && data.data && data.data.check_in_time) {
          updateShiftDisplay(data.data.check_in_time, data.data.check_out_time);
        } else {
          updateShiftDisplay(null, null);
        }
      })
      .catch(() => {});
  };

  useEffect(() => {
    fetchLiveAttendance();
    // Poll backend periodically (60s) to keep status fresh without overloading server
    const pollInterval = setInterval(fetchLiveAttendance, 60000);
    // Tick local timer every second
    const tickInterval = setInterval(() => {
      const cur = liveShiftRef.current;
      if (cur.clockedIn && cur.checkInTime && !cur.checkOutTime) {
        const diffSec = Math.max(0, moment().diff(cur.checkInTime, "seconds"));
        const hrs = String(Math.floor(diffSec / 3600)).padStart(2, "0");
        const mins = String(Math.floor((diffSec % 3600) / 60)).padStart(2, "0");
        const secs = String(diffSec % 60).padStart(2, "0");
        setLiveShift((prev) => ({
          ...prev,
          duration: `${hrs}:${mins}:${secs}`
        }));
      }
    }, 1000);

    return () => {
      clearInterval(pollInterval);
      clearInterval(tickInterval);
    };
  }, []);

  const [mgrStats, setMgrStats] = useState({
    loading: false,
    staffCount: 0,
    pendingLeaves: 0,
    weeklyShiftsCount: 0
  });

  const [cqcStats, setCqcStats] = useState({
    loading: false,
    totalDocs: 0,
    evidenceUploaded: 0
  });

  const [userLeaveStats, setUserLeaveStats] = useState({ available: 0, taken: 0, pending: 0, total: 0 });
  const [userDocStats, setUserDocStats] = useState({ total: 0, app_count: 0, pend_count: 0, expire_count: 0 });

  const isSuperUser = Boolean(userData.is_super_user === true || userData.is_super_user === 1 || userData.is_super_user === "1" || userData.is_super_user === "true");
  const isManager = Boolean(isSuperUser || userData.manager === true || userData.manager === 1 || userData.manager === "1" || userData.manager === "true");
  const isCqcUser = Boolean(userData.is_cqc === true || userData.is_cqc === 1 || userData.is_cqc === "1" || userData.is_cqc === "true" || Utils.hasAccess(11) || isSuperUser);
  const isRotaUser = Boolean(userData.is_rota === true || userData.is_rota === 1 || userData.is_rota === "1" || userData.is_rota === "true" || Utils.hasAccess(12) || isSuperUser);

  const fetchRoleStats = () => {
    if (isManager) {
      setMgrStats((s) => ({ ...s, loading: true }));
      const dtf = moment().startOf('isoWeek').format('YYYY-MM-DD');
      const dtt = moment().endOf('isoWeek').format('YYYY-MM-DD');
      const branchId = userData.branch_id || 0;

      const promises = [
        axios.get(Utils.apiUrl("leaves/fetchteamrequests?from=" + moment().startOf('year').format('YYYY-MM-DD') + "&to=" + moment().endOf('year').format('YYYY-MM-DD')), Utils.apiHeaders()).catch(() => ({ data: {} })),
        axios.get(Utils.apiUrl(`users/fetchrotas?filter[mode]=week&filter[branch]=${branchId}&filter[dtf]=${dtf}&filter[dtt]=${dtt}`), Utils.apiHeaders()).catch(() => ({ data: {} }))
      ];

      if (isSuperUser) {
        promises.push(axios.get(Utils.apiUrl("users/fetchBranches?orgMembers=1"), Utils.apiHeaders()).catch(() => ({ data: {} })));
      }

      Promise.all(promises).then(([lRes, rRes, uRes]) => {
        const lData = Utils.parseApiResponse(lRes);
        const rData = Utils.parseApiResponse(rRes);
        const uData = uRes ? Utils.parseApiResponse(uRes) : null;

        // Staff count: Practice staff for super users, or direct team members for managers
        let staffCount = 0;
        if (isSuperUser && uData) {
          if (Array.isArray(uData?.braMembers)) {
            staffCount = uData.braMembers.length;
          } else if (Array.isArray(uData?.orgMembers)) {
            staffCount = uData.orgMembers.filter(m => !branchId || parseInt(m.branch_id) === parseInt(branchId)).length;
          } else if (Array.isArray(uData?.users)) {
            staffCount = uData.users.filter(m => !branchId || parseInt(m.branch_id) === parseInt(branchId)).length;
          }
        } else if (Array.isArray(lData?.team)) {
          staffCount = lData.team.length;
        }

        // Direct reports' pending holiday requests ONLY (excluding disapproved/recalled records):
        const pendingLeaves = Array.isArray(lData?.records) 
          ? lData.records.filter(r => {
              const isNullApproved = r.is_approved === null || r.is_approved === undefined || r.is_approved === "";
              const isRecallRequested = r.manager_reason && String(r.manager_reason).includes('[RECALL REQUESTED');
              const isRecalled = (r.manager_reason && String(r.manager_reason).includes('Recalled')) || (r.reason && String(r.reason).includes('recalled'));
              return (isNullApproved && !isRecalled) || isRecallRequested;
            }).length 
          : 0;

        const weeklyShiftsCount = Array.isArray(rData?.rotas) ? rData.rotas.length : 0;

        setMgrStats({
          loading: false,
          staffCount,
          pendingLeaves,
          weeklyShiftsCount
        });
      }).catch(() => setMgrStats((s) => ({ ...s, loading: false })));
    }

    // Normal staff personal metrics
    axios.get(Utils.apiUrl("leaves/fetchleavessummary"), Utils.apiHeaders())
      .then(res => {
        const d = Utils.parseApiResponse(res);
        if (d.success && d.summary) {
          setUserLeaveStats(d.summary);
        }
      }).catch(() => {});

    axios.get(Utils.apiUrl("users/fetchprofile"), Utils.apiHeaders())
      .then(res => {
        const d = Utils.parseApiResponse(res);
        if (d.success && d.counts && d.counts[0]) {
          setUserDocStats(d.counts[0]);
        }
      }).catch(() => {});

    if (isCqcUser || isSuperUser) {
      setCqcStats((s) => ({ ...s, loading: true }));
      axios.get(Utils.apiUrl("cqcs/fetchprofile"), Utils.apiHeaders())
        .then(res => {
          const data = Utils.parseApiResponse(res);
          if (data.success && Array.isArray(data.userdocs)) {
            const totalDocs = data.userdocs.length;
            const evidenceUploaded = data.userdocs.filter(d => d.fid && parseInt(d.fid) > 0).length;
            setCqcStats({
              loading: false,
              totalDocs,
              evidenceUploaded
            });
          } else {
            setCqcStats({ loading: false, totalDocs: 0, evidenceUploaded: 0 });
          }
        })
        .catch(() => setCqcStats({ loading: false, totalDocs: 0, evidenceUploaded: 0 }));
    }
  };

  useEffect(() => {
    fetchJobStats();
    fetchTaskStats();
    fetchTeamSummary();
    fetchMyRota();
    fetchRoleStats();
  }, []); // eslint-disable-line

  const goto = (path) => (e) => {
    window.location.href = process.env.PUBLIC_URL + path;
  };

  const handleThemeChange = (theme) => {
    setCardTheme(theme);
    localStorage.setItem("dt_card_theme", theme);
  };

  return (
    <div className={`dt-dashboard-page dt-theme-${cardTheme}`}>
      {/* Dashboard Card Style Preference Bar */}


      {/* 1. Hero Live Shift Console (All Users) */}
      <section className="shift">
        <div className="shift__greet">
          <div className="eyebrow" style={{ color: "#BFD5EF" }}>
            {moment().format("dddd, D MMMM YYYY")}
          </div>
          <h1 className="shift__hello">
            Welcome back, {_.get(userData, "name", "Doctor")}
          </h1>
          <p className="shift__meta">
            {_.get(userData, "braname") || _.get(userData, "branch_name") || _.get(userData, "practice_name") || _.get(userData, "orgname") || "Main Branch"}
          </p>
        </div>

        <div className="shift__clock">
          <div className="shift__selfie">
            {_.get(userData, "name", "D").charAt(0).toUpperCase()}
            <span className="cam">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><path d="M4 8h3l1.5-2h7L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1Z"/><circle cx="12" cy="13" r="3.2"/></svg>
            </span>
          </div>
          <div>
            <div className="shift__timer num" style={{ fontSize: liveShift.clockedIn ? "30px" : "20px" }}>
              {liveShift.duration}
            </div>
            <div className="shift__timerlbl">
              <span className={liveShift.clockedIn ? "pulse" : ""} style={{ width: 8, height: 8, borderRadius: "50%", background: liveShift.clockedIn ? "#10B981" : "#EF4444" }}></span>
              {liveShift.statusText}
            </div>
          </div>
        </div>

        <div className="shift__act">
          {Utils.hasAccess(2) && (
            <button className="dt-btn dt-btn--ghost" onClick={goto("/attendance")} style={{ background: "#fff", color: "var(--dt-navy)", fontWeight: 700 }}>
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.2 1.9"/></svg>
              Time Hub &amp; Clock In
            </button>
          )}
          {Utils.hasAccess(5) && (
            <button className="dt-btn dt-btn--ghost" onClick={goto("/leave")} style={{ border: "1.5px solid rgba(255,255,255,0.3)", color: "#fff", background: "transparent", fontWeight: 600 }}>
              Holidays
            </button>
          )}
        </div>
      </section>

      {/* 2. SUPER USER & TEAM MANAGER COMMAND CENTER */}
      {isManager && (
        <section className="dt-card">
          <div className="dt-card__head d-flex align-items-center justify-content-between flex-row w-100 mb-3">
            <div className="d-flex align-items-center gap-2">
              <span className="dt-section-label dt-section-label--primary">
                <span className="dt-section-label__dot"></span> {isSuperUser ? "SUPER USER COMMAND" : "TEAM COMMAND"}
              </span>
              <h2 className="dt-card__title dt-card__title--exec m-0 d-none d-sm-block">
                {isSuperUser ? "Live Practice Operations Summary" : "My Team Operations Summary"}
              </h2>
            </div>
            <button className="dt-pill-btn" onClick={goto(isSuperUser ? "/users" : "/leave")}>
              {isSuperUser ? "Team Directory →" : "Team Holidays →"}
            </button>
          </div>
          <div className="streaks-grid">
            <div className="dt-streak clickable" onClick={goto(isSuperUser ? "/users" : "/leave")} title={isSuperUser ? "Total active staff members in practice" : "Direct reporting team members"}>
              <div className="dt-streak__ico" style={{ background: "rgba(0, 122, 255, 0.12)", color: "#007AFF" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="9" cy="8" r="3.2"/><path d="M3.5 20c0-3.2 2.5-5.5 5.5-5.5s5.5 2.3 5.5 5.5"/><path d="M16.5 5.5a3 3 0 0 1 0 5.6M18 20c0-2.2-.7-4-1.9-5.2"/></svg>
              </div>
              <div className="dt-streak__body">
                <div className="dt-streak__n" style={{ color: "#007AFF" }}>
                  {mgrStats.loading ? "..." : mgrStats.staffCount}
                </div>
                <div className="dt-streak__l">{isSuperUser ? "Active Staff Members" : "My Team Members"}</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/leave")} title="Pending holiday requests for staff reporting to me">
              <div className="dt-streak__ico" style={{ background: mgrStats.pendingLeaves > 0 ? "rgba(239, 68, 68, 0.12)" : "rgba(245, 158, 11, 0.12)", color: mgrStats.pendingLeaves > 0 ? "#EF4444" : "#D97706" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              </div>
              <div className="dt-streak__body">
                <div className="dt-streak__n" style={{ color: mgrStats.pendingLeaves > 0 ? "#EF4444" : "#D97706" }}>
                  {mgrStats.loading ? "..." : mgrStats.pendingLeaves}
                </div>
                <div className="dt-streak__l">Pending Holiday Approvals</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/jobs/delayed")} title="My overdue jobs">
              <div className="dt-streak__ico" style={{ background: "rgba(239, 68, 68, 0.12)", color: "#EF4444" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
              </div>
              <div className="dt-streak__body">
                <div className="dt-streak__n" style={{ color: "#EF4444" }}>
                  {_.get(jobStat, "stats.0", "0")}
                </div>
                <div className="dt-streak__l">My Overdue Jobs</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/comrota")} title="Weekly scheduled shifts">
              <div className="dt-streak__ico" style={{ background: "rgba(16, 185, 129, 0.12)", color: "#10B981" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
              </div>
              <div className="dt-streak__body">
                <div className="dt-streak__n" style={{ color: "#10B981" }}>
                  {mgrStats.loading ? "..." : mgrStats.weeklyShiftsCount}
                </div>
                <div className="dt-streak__l">{isSuperUser ? "Practice Shifts This Week" : "Weekly Shifts"}</div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 2.5 NORMAL USER PERSONAL WORKSPACE & COMPLIANCE (For Staff Users) */}
      {!isSuperUser && (
        <section className="dt-card">
          <div className="dt-card__head d-flex align-items-center justify-content-between flex-row w-100 mb-3">
            <div className="d-flex align-items-center gap-2">
              <span className="dt-section-label dt-section-label--primary">
                <span className="dt-section-label__dot"></span> MY WORKSPACE
              </span>
              <h2 className="dt-card__title dt-card__title--exec m-0 d-none d-sm-block">Personal Holiday &amp; Compliance Overview</h2>
            </div>
            <button className="dt-pill-btn" onClick={goto("/myprofile")}>
              My Profile →
            </button>
          </div>
          <div className="streaks-grid">
            <div className="dt-streak clickable" onClick={goto("/leave")} title="My available annual holiday leave balance">
              <div className="dt-streak__ico" style={{ background: "rgba(16, 185, 129, 0.12)", color: "#10B981" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="m9 12 2 2 4-4"/></svg>
              </div>
              <div className="dt-streak__body">
                <div className="dt-streak__n" style={{ color: "#10B981" }}>
                  {userLeaveStats.available || "0"} <span style={{ fontSize: "11px", fontWeight: 600 }}>Days</span>
                </div>
                <div className="dt-streak__l">Available Holidays</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/leave")} title="Pending leave requests awaiting practice manager review">
              <div className="dt-streak__ico" style={{ background: "rgba(245, 158, 11, 0.12)", color: "#D97706" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
              </div>
              <div className="dt-streak__body">
                <div className="dt-streak__n" style={{ color: "#D97706" }}>
                  {userLeaveStats.pending || "0"} <span style={{ fontSize: "11px", fontWeight: 600 }}>Days</span>
                </div>
                <div className="dt-streak__l">Pending Holiday Requests</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/myprofile")} title="Approved compliance certificates in my profile">
              <div className="dt-streak__ico" style={{ background: "rgba(0, 122, 255, 0.12)", color: "#007AFF" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
              </div>
              <div className="dt-streak__body">
                <div className="dt-streak__n" style={{ color: "#007AFF" }}>
                  {userDocStats.app_count || "0"} / {userDocStats.total || "0"}
                </div>
                <div className="dt-streak__l">Compliance Docs Approved</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/myprofile")} title="Documents requiring update or renewal">
              <div className="dt-streak__ico" style={{ background: parseInt(userDocStats.expire_count) > 0 ? "rgba(239, 68, 68, 0.12)" : "rgba(100, 116, 139, 0.12)", color: parseInt(userDocStats.expire_count) > 0 ? "#EF4444" : "#64748B" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
              </div>
              <div className="dt-streak__body">
                <div className="dt-streak__n" style={{ color: parseInt(userDocStats.expire_count) > 0 ? "#EF4444" : "#64748B" }}>
                  {userDocStats.expire_count || "0"}
                </div>
                <div className="dt-streak__l">Documents Due Renewal</div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 3. CQC COMPLIANCE COMMAND CENTER (For CQC Users) */}
      {isCqcUser && (
        <section className="dt-card">
          <div className="dt-card__head d-flex align-items-center justify-content-between flex-row w-100 mb-3">
            <div className="d-flex align-items-center gap-2">
              <span className="dt-section-label dt-section-label--success">
                <span className="dt-section-label__dot"></span> CQC COMPLIANCE
              </span>
              <h2 className="dt-card__title dt-card__title--cqc m-0 d-none d-sm-block">Inspection Readiness &amp; Quality Statements</h2>
            </div>
            <button className="dt-pill-btn dt-pill-btn--success" onClick={goto("/cqc")}>
              Open CQC Hub →
            </button>
          </div>
          <div className="streaks-grid">
            <div className="dt-streak clickable" onClick={goto("/cqc")} title="Total Quality Statements monitored">
              <div className="dt-streak__ico" style={{ background: "rgba(16, 185, 129, 0.12)", color: "#10B981" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "#10B981" }}>
                  {cqcStats.loading ? "..." : cqcStats.totalDocs}
                </div>
                <div className="dt-streak__l">Quality Statements Monitored</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/cqc")} title="Evidence documents verified">
              <div className="dt-streak__ico" style={{ background: "rgba(0, 122, 255, 0.12)", color: "#007AFF" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "#007AFF" }}>
                  {cqcStats.loading ? "..." : cqcStats.evidenceUploaded}
                </div>
                <div className="dt-streak__l">Audits &amp; Evidence Logged</div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 4. ROTA & SHIFTS COMMAND CENTER (For Rota Users & Staff) */}
      {isRotaUser && (
        <section className="dt-card">
          <div className="dt-card__head d-flex align-items-center justify-content-between flex-row w-100 mb-3">
            <div className="d-flex align-items-center gap-2">
              <span className="dt-section-label dt-section-label--primary">
                ROTA &amp; SHIFTS COMMAND
              </span>
              <h2 className="dt-card__title dt-card__title--rota m-0 d-none d-sm-block">Duty Roster &amp; Shift Coverage</h2>
            </div>
            <div className="d-flex gap-2">
              <button className="dt-pill-btn dt-pill-btn--primary" onClick={goto("/comrota")}>
                {isSuperUser ? "Master Rota →" : "Full Rota →"}
              </button>
            </div>
          </div>

          <div className="streaks-grid mb-3">
            <div className="dt-streak clickable" onClick={goto("/myrota")} title="My assigned shifts this week">
              <div className="dt-streak__ico" style={{ background: "rgba(0, 122, 255, 0.12)", color: "#007AFF" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="9"/><path d="M12 7v5l3.2 1.9"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "#007AFF" }}>
                  {myRotas.loading ? "..." : myRotas.records.length}
                </div>
                <div className="dt-streak__l">My Shifts (This Week)</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto(isSuperUser ? "/comrota" : "/myrota")} title="Today's duty shift">
              <div className="dt-streak__ico" style={{ background: "rgba(16, 185, 129, 0.12)", color: "#10B981" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "#10B981" }}>
                  {myRotas.records.some(r => (r.rota_date === moment().format("YYYY-MM-DD") || r.rdate === moment().format("YYYY-MM-DD") || r.date === moment().format("YYYY-MM-DD"))) ? "On Duty" : "Rest Day"}
                </div>
                <div className="dt-streak__l">Today's Shift Status</div>
              </div>
            </div>

            {isSuperUser && (
              <div className="dt-streak clickable" onClick={goto("/comrota")} title="Practice shifts scheduled this week">
                <div className="dt-streak__ico" style={{ background: "rgba(14, 165, 233, 0.12)", color: "#0284C7" }}>
                  <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
                </div>
                <div>
                  <div className="dt-streak__n" style={{ color: "#0284C7" }}>
                    {mgrStats.loading ? "..." : mgrStats.weeklyShiftsCount}
                  </div>
                  <div className="dt-streak__l">Practice Shifts This Week</div>
                </div>
              </div>
            )}
          </div>

          {/* 7-Day Weekly Shift Grid */}
          <div className="pt-3 border-top">
            <div className="d-flex justify-content-between align-items-center mb-2">
              <span className="text-muted small fw-bold text-uppercase" style={{ letterSpacing: "0.05em", fontSize: "11px" }}>
                Weekly Shift Schedule ({moment().startOf('isoWeek').format('D MMM')} – {moment().endOf('isoWeek').format('D MMM YYYY')})
              </span>
            </div>
            {myRotas.loading && (
              <div className="text-center py-3 text-muted small">
                <Spinner animation="border" size="sm" variant="primary" className="me-2" />
                Loading shift schedule...
              </div>
            )}
            {!myRotas.loading && (
              <div className="row g-2 g-md-3">
                {[0, 1, 2, 3, 4, 5, 6].map((dayOffset) => {
                  const dayDate = moment().startOf('isoWeek').add(dayOffset, 'days');
                  const dateStr = dayDate.format('YYYY-MM-DD');
                  const isToday = dayDate.isSame(moment(), 'day');
                  const isoDay = dayDate.isoWeekday(); // 1=Mon ... 7=Sun
                  const isWeekend = isoDay === 6 || isoDay === 7;
                  const dayRota = myRotas.records.find((r) => r.rota_date === dateStr || r.rdate === dateStr || r.date === dateStr);

                  // Check if user has working days configured in wday_hours
                  let isWorkingDay = !isWeekend;
                  if (userData?.wday_hours) {
                    const hoursArr = String(userData.wday_hours).split(",");
                    if (hoursArr[isoDay] !== undefined) {
                      isWorkingDay = Number(hoursArr[isoDay]) > 0;
                    }
                  }

                  let statusTitle = "No Rota";
                  let statusBadgeClass = "bg-warning text-dark";
                  let statusBadgeText = "No Rota";
                  let subtitle = "Awaiting Shift";

                  if (dayRota) {
                    statusTitle = dayRota.shift_time || dayRota.title || (dayRota.slot ? (dayRota.slot === 'fd' ? 'Full Day Shift' : dayRota.slot === 'am' ? 'Morning Shift (AM)' : 'Afternoon Shift (PM)') : "Scheduled Shift");
                    statusBadgeClass = "bg-success";
                    statusBadgeText = "Working";
                    subtitle = dayRota.role_name || dayRota.dept || dayRota.braname || "General Duty";
                  } else if (!isWorkingDay) {
                    statusTitle = "Off Duty";
                    statusBadgeClass = "bg-light text-secondary border";
                    statusBadgeText = "Off Duty";
                    subtitle = "Scheduled Rest Day";
                  }

                  return (
                    <div className="col-12 col-sm-6 col-md" key={dayOffset}>
                      <div
                        className="p-2 rounded border h-100 d-flex flex-column justify-content-between"
                        style={{
                          background: isToday ? "#EFF6FF" : "#FFFFFF",
                          borderColor: isToday ? "#007AFF" : "#CBD5E1",
                          borderWidth: isToday ? "2px" : "1.5px"
                        }}
                      >
                        <div>
                          <div className="d-flex justify-content-between align-items-center mb-1">
                            <span className="fw-bold" style={{ fontSize: "13px", color: isToday ? "#007AFF" : "#1E293B" }}>
                              {dayDate.format("ddd, D MMM")}
                            </span>
                            {isToday && <span className="badge bg-primary" style={{ fontSize: "10px" }}>Today</span>}
                          </div>
                          <div className="small fw-semibold text-dark mt-1 text-truncate" title={statusTitle}>
                            {statusTitle}
                          </div>
                        </div>
                        <div className="mt-2 pt-1 border-top small text-muted d-flex justify-content-between align-items-center" style={{ fontSize: "11px" }}>
                          <span className="text-truncate me-1">{subtitle}</span>
                          <span className={`badge flex-shrink-0 ${statusBadgeClass}`}>
                            {statusBadgeText}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </section>
      )}

      {/* 4.8 Personal Jobs Outlook */}
      {Utils.hasAccess(3) && (
        <section className="dt-card">
          <div className="dt-card__head">
            <h2 className="dt-card__title dt-card__title--workflow">Jobs Outlook</h2>
            <div className="d-flex align-items-center gap-2">
              {jobStat.loading && <Spinner animation="border" size="sm" variant="primary" />}
              <button className="dt-pill-btn" onClick={goto("/jobs")}>All Jobs →</button>
            </div>
          </div>
          <div className="streaks-grid">
            <div className="dt-streak clickable" onClick={goto("/jobs/delayed")} title="Delayed Backlog Jobs">
              <div className="dt-streak__ico" style={{ background: "var(--coral-wash)", color: "var(--coral)" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "var(--coral)" }}>
                  {_.get(jobStat, "stats.0", "0")}
                </div>
                <div className="dt-streak__l">Delayed Backlog</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/jobs/upcoming")} title="Today's Jobs Due">
              <div className="dt-streak__ico" style={{ background: "var(--amber-wash)", color: "var(--amber)" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "var(--amber)" }}>
                  {_.get(jobStat, "stats.1", "0")}
                </div>
                <div className="dt-streak__l">Due Today</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/jobs/complete")} title="Completed Jobs this week">
              <div className="dt-streak__ico" style={{ background: "var(--mint-wash)", color: "var(--mint)" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "var(--mint)" }}>
                  {_.get(jobStat, "stats.2", "0")}
                </div>
                <div className="dt-streak__l">Completed (This week)</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/jobs")} title="Total Assigned Active Jobs">
              <div className="dt-streak__ico" style={{ background: "var(--brand-wash)", color: "var(--dt-action)" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 5H7a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "var(--dt-action)" }}>
                  {jobStat.loading ? "..." : (parseInt(_.get(jobStat, "stats.0", 0)) + parseInt(_.get(jobStat, "stats.1", 0)) + parseInt(_.get(jobStat, "stats.2", 0)))}
                </div>
                <div className="dt-streak__l">Active Assigned Jobs</div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 5. Personal Tasks Outlook */}
      {Utils.hasAccess(4) && (
        <section className="dt-card">
          <div className="dt-card__head">
            <h2 className="dt-card__title dt-card__title--tasks">Tasks Outlook</h2>
            <div className="d-flex align-items-center gap-2">
              {taskStat.loading && <Spinner animation="border" size="sm" variant="primary" />}
              <button className="dt-pill-btn" onClick={goto("/todo")}>All Tasks →</button>
            </div>
          </div>
          <div className="streaks-grid">
            <div className="dt-streak clickable" onClick={goto("/todo/delayed")} title="Delayed Tasks">
              <div className="dt-streak__ico" style={{ background: "var(--coral-wash)", color: "var(--coral)" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4M12 16h.01"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "var(--coral)" }}>
                  {_.get(taskStat, "stats.0", "0")}
                </div>
                <div className="dt-streak__l">Delayed Backlog</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/todo/upcoming")} title="Today's Tasks">
              <div className="dt-streak__ico" style={{ background: "var(--amber-wash)", color: "var(--amber)" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><path d="M16 2v4M8 2v4M3 10h18"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "var(--amber)" }}>
                  {_.get(taskStat, "stats.1", "0")}
                </div>
                <div className="dt-streak__l">Due Today</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/todo/complete")} title="Completed Tasks">
              <div className="dt-streak__ico" style={{ background: "var(--mint-wash)", color: "var(--mint)" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="m5 12.5 4.5 4.5L19 7"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "var(--mint)" }}>
                  {_.get(taskStat, "stats.2", "0")}
                </div>
                <div className="dt-streak__l">Completed (This week)</div>
              </div>
            </div>

            <div className="dt-streak clickable" onClick={goto("/todo/upcoming30days")} title="30 Days Outlook">
              <div className="dt-streak__ico" style={{ background: "var(--brand-wash)", color: "var(--dt-action)" }}>
                <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"/></svg>
              </div>
              <div>
                <div className="dt-streak__n" style={{ color: "var(--dt-action)" }}>
                  {_.get(taskStat, "stats.3", "0")}
                </div>
                <div className="dt-streak__l">Upcoming (30 Days)</div>
              </div>
            </div>
          </div>
        </section>
      )}

      {/* 6. Team's Summary (For Managers, Super Users, or Staff with reportees) */}
      {(isSuperUser || (summary.records && summary.records.length > 1)) && Utils.hasAccess(3) && (
        <section className="dt-card dt-card--flush">
          <div className="dt-card__head" style={{ padding: "16px 20px 0", marginBottom: "8px" }}>
            <h2 className="dt-card__title dt-card__title--team">
              Team's Summary <span className="text-muted fw-normal small" style={{ fontSize: "12px" }}>(Staff Jobs Progress)</span>
            </h2>
          </div>
          <div>
            {summary.loading && (
              <div className="p-4 text-center">
                <Spinner animation="border" variant="primary" />
                <p className="mt-2 text-muted">Fetching team's summary...</p>
              </div>
            )}
            {!summary.loading && (
              <>
                {summary.total === 0 && (
                  <div className="alert alert-warning m-3 p-3">
                    <b>No Team's Summary found!</b>
                  </div>
                )}
                {summary.total > 0 && (
                  <div className="table-responsive">
                    <table className="dt-table">
                      <thead>
                        <tr>
                          <th width="70" className="d-none d-sm-table-cell">Sr.</th>
                          <th>Staff Name</th>
                          <th className="d-none d-sm-table-cell">Role / Designation</th>
                          <th width="120" className="text-center">Jobs Complete</th>
                          <th width="120" className="text-center">Jobs Overdue</th>
                          <th width="120" className="text-center">Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {summary.records.map((r, idx) => (
                          <tr key={idx}>
                            <td className="d-none d-sm-table-cell text-muted">
                              {Utils.addZero(summary.st + idx + 1)}.
                            </td>
                            <td>
                              <strong>{r.name}</strong>
                            </td>
                            <td className="d-none d-sm-table-cell text-muted">
                              {r.designation}
                            </td>
                            <td className="text-center">
                              <span className="chip chip--ok">{r.completed}</span>
                            </td>
                            <td className="text-center">
                              {parseInt(r.backlog) > 0 ? (
                                <span className="chip chip--over">{r.backlog}</span>
                              ) : (
                                <span className="chip chip--ok">0</span>
                              )}
                            </td>
                            <td className="text-center">
                              {parseInt(r.backlog) > 0 ? (
                                <span className="chip chip--over">Overdue</span>
                              ) : parseInt(r.completed) > 0 ? (
                                <span className="chip chip--ok">Up to date</span>
                              ) : (
                                <span className="chip chip--due">No Pending</span>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="p-3">
                  {showPagination(summary, fetchTeamSummary)}
                </div>
              </>
            )}
          </div>
        </section>
      )}
    </div>
  );
};
export default Dashboard;
